import React from 'react';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { Container } from '../../UI/Container/Container';
import { Grid, GridRow, GridCol } from '../../UI/Grid';
import { VisualImages } from './types';

const Boxed: React.StatelessComponent<VisualImages> = ({ images }): any =>
    images[0].visual_image.url &&
    images[0].visual_image_atl.text && (
        <Container size="md" className="Visual-boxedImage">
            <Grid>
                <GridRow horizontalAlign={'h-start'} verticalAlign={'v-center'}>
                    <GridCol colSize={`12`}>
                        <img
                            src={images[0].visual_image.url}
                            alt={images[0].visual_image_atl.text}
                        />
                        {images[0].visual_image_description.html && (
                            <PrismicHTMLParser className="Visual-boxedImageDescription">
                                {images[0].visual_image_description.html}
                            </PrismicHTMLParser>
                        )}
                    </GridCol>
                </GridRow>
            </Grid>
        </Container>
    );

export default Boxed;
